import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

/** The Temperatures screen's in-app delete confirmation (never `window.confirm`). */
export function ConfirmDeleteDialog({
  name,
  open,
  pending,
  onCancel,
  onConfirm,
  children,
}: {
  name: string
  open: boolean
  pending: boolean
  onCancel: () => void
  onConfirm: () => void
  /** What deleting it does, beyond "cannot be undone". */
  children?: ReactNode
}) {
  return (
    <Dialog open={open} onOpenChange={next => !next && onCancel()}>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Delete "{name}"?</DialogTitle>
          <DialogDescription>This cannot be undone.</DialogDescription>
        </DialogHeader>
        {children && <div className='text-sm text-muted-foreground'>{children}</div>}
        <DialogFooter>
          <Button variant='outline' onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button variant='destructive' onClick={onConfirm} disabled={pending}>
            {pending ? 'Deleting…' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
